import IscSvgIcon from './isc-svg-icon.vue';

IscSvgIcon.install = (vue, options) => {
    vue.component(IscSvgIcon.name, IscSvgIcon);

    if (options.common || options.common == null) {
        import('./assets/common.iconfont');
    }
    if (options.nav) {
        import('./assets/nav.iconfont');
    }
    if (options.business) {
        import('./assets/business.iconfont');
    }
};

export default IscSvgIcon;
